import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Card, CardHeader, CardContent, Hidden } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { genfunction } from 'helpers';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import ReactHtmlParser from 'react-html-parser';
import { NumberSpinner } from 'components/InputControls';

const { ChaperoneHeading } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: "7px 0px 7px 25px"
    },
    box100per: {
        width: "100%"
    }
}));

const Chaperone = (props) => {
    const classes = useStyles();

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0];
    const apiData = useSelector(state => state.reducerExtraItems.extraItem);

    const productPrice = (priceMatrix) => {

        return priceMatrix !== undefined && priceMatrix.length > 0 ?
            genfunction.ccyFormat(priceMatrix[0].Price) : genfunction.ccyFormat(0);
    }

    return (
        <div >

            {apiData.hasOwnProperty("TourProducts") && apiData.TourProducts.filter(x => x.TourProductID === bkngType.ChaperoneTourProductID).length > 0 ?
                <Card style={{ borderRadius: "0" }} className={classes.box100per}>
                    <CardHeader className={classes.tourheaderbox}
                        title={ChaperoneHeading}
                        titleTypographyProps={{ color: "inherit" }}
                    />

                    <CardContent>

                        <Grid style={{ padding: "10px 15px 0px 15px" }} container alignItems="center" item xs={12} ms={12} lg={12}>
                            {apiData.TourProducts.filter(x => x.TourProductID === bkngType.ChaperoneTourProductID).map((product, i) => {

                                return (
                                    <Grid container alignItems="center" item xs={12} ms={12} lg={12} key={product.TourProductID}>
                                        <Grid item xs={2} ms={2} lg={2}>
                                            <Tooltip title={ReactHtmlParser(genfunction.replaceEscapeCharacters(product.Information))} enterTouchDelay={0} leaveTouchDelay={3000}>
                                                <InfoIcon arrow="true" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6} ms={6} lg={6}>
                                            <Hidden smDown>
                                                <Typography variant="h4">{product.TourProductName + ' ' + productPrice(product.PriceMatrix)}</Typography>
                                            </Hidden>

                                            <Hidden xsDown mdUp>
                                                <Typography variant="h5">{product.TourProductName + ' ' + productPrice(product.PriceMatrix)}</Typography>
                                            </Hidden>

                                            <Hidden smUp>
                                                <Typography variant="h6">{product.TourProductName + ' ' + productPrice(product.PriceMatrix)}</Typography>
                                            </Hidden>

                                        </Grid>

                                        <Grid item xs={4} ms={4} lg={4}>
                                            <NumberSpinner
                                                refrence={{
                                                    TourProductID: product.TourProductID
                                                }}
                                                value={product.Quantity ? product.Quantity : 0}
                                                minValue={product.Quantity ? product.Quantity : 0}
                                                maxValue={product.Quantity ? product.Quantity : 0}

                                            ></NumberSpinner>

                                        </Grid>
                                    </Grid>

                                )
                            })}
                        </Grid>

                    </CardContent>
                </Card>
                : null}

        </div>
    )
}

export default Chaperone